// extracted by css-extract-rspack-plugin
export default {"root":"swDF1","measuring":"gR9KP","body":"oEzXA"};